let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8nmUr")).then(() => parcelRequire('4R9ta'));